"use client";

import React from "react";

const GoToEmergencyDentist: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          We&apos;re the Go-to Emergency Dentist Astoria Residents Trust
        </h2>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          At Smile4Me Dental Care, we&apos;re proud to be the{" "}
          <a
            href="https://maps.google.com/maps?cid=8192593597492375843"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
            aria-label="Dentist in Astoria on Google Maps"
          >
            dentist in Astoria
          </a>{" "}
          that families turn to for urgent dental care. We&apos;re equipped with
          the tools, experience, and compassion to handle your case on the spot.
          From your first call to your final treatment, we focus on getting you
          out of pain and back to smiling as quickly and comfortably as
          possible.
        </p>

      </div>
    </section>
  );
};

export default GoToEmergencyDentist;
